export const selectDateOfBirth = (state) => state.entities?.profile?.date_of_birth;
